import { http } from "@/utils/request";

/**
 * 获取业绩报告列表
 */
export const useGetAchieventListApi = async (params) => {
  console.log("业绩报告接口-请求参数", params);
  const res = await http.post("/companyOfficialWebsite/siteReportListForOut", params);
  console.log("业绩报告接口-返回数据", res);
  return res;
};
